import { getAge, isDate } from '@/features/shared/tools'
import { nafAutoriseTT } from '../shared'
import type { ContratProDTO } from '@/features/api/extranet/dto/Demande/CPRO'

export * from '@/features/domaine/regles-akto/shared/preconditions'

/* Sépcifiques métier */
export const preNafTT = (_value: any, _parent: any, modele: ContratProDTO) =>
  modele?.employeur?.etablissement?.naf?.code === nafAutoriseTT

export const preMineur = (_value: any, _parent: any, modele: ContratProDTO) =>
  isDate(modele.salarie?.dateNaissance) &&
  isDate(modele.contrat?.dateConclusion) &&
  getAge(new Date(modele.salarie.dateNaissance), new Date(modele.contrat.dateConclusion)) < 18
export const preMajeur = (_value: any, _parent: any, modele: ContratProDTO) =>
  isDate(modele.salarie?.dateNaissance) &&
  isDate(modele.contrat?.dateConclusion) &&
  getAge(new Date(modele.salarie.dateNaissance), new Date(modele.contrat.dateConclusion)) >= 18

export const preNotNirTemporaire = (_value: any, _parent: any, modele: ContratProDTO) =>
  modele.salarie?.nirTemporaire !== true
export const preNirTemporaire = (_value: any, _parent: any, modele: ContratProDTO) =>
  modele.salarie?.nirTemporaire === true
